export class SortOptions {

  public field : string;
  public reverse: boolean;

  constructor(field: string, reverse: boolean) {
    this.field = field;
    this.reverse = reverse;
  }
  
}
